import React from "react";
import { createRoot } from 'react-dom/client';
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { AuthProvider } from "react-oidc-context";
import { azureUserManagerConfig } from "./utils/OIDC/authConst";
import { BrowserRouter } from "react-router-dom";
import "./index.scss";

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(
  <AuthProvider {...(azureUserManagerConfig)}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
  </AuthProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
